import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from 'environments/environment';
import { AppModule } from 'app/app.module';
import * as Sentry from "@sentry/angular";
import { ModuleRegistry, AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { AG_GRID_LICENSE_KEY } from 'app/core/config/ag-grid.config';

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

if ( environment.production )
{
    enableProdMode();
    Sentry.init({
        dsn: "https://618db4a5f6ea15f764cce97e1452b09e@o4506556425371648.ingest.us.sentry.io/4508299525554176",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration()
        ],
    });
}

platformBrowserDynamic().bootstrapModule(AppModule)
                        .catch(err => console.error(err));
